(() => {
  const sliders = document.querySelectorAll('[data-casemeta-media-slider]');

  sliders.forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-casemeta-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-casemeta-dot]'));

    if (slides.length <= 1) return;

    let currentIndex = 0;
    let timer = null;
    let resetTimer = null;

    const resetHiddenVideos = (activeSlide) => {
      slides.forEach((slide) => {
        if (slide === activeSlide) return;

        slide.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });
      });
    };

    const playActiveVideo = (activeSlide) => {
      const video = activeSlide.querySelector('video');

      if (!video) return;

      video.muted = true;
      video.playsInline = true;
      video.currentTime = 0;
      video.play().catch(() => {});
    };

    const showSlide = (index) => {
      window.clearTimeout(timer);
      window.clearTimeout(resetTimer);

      currentIndex = (index + slides.length) % slides.length;
      const activeSlide = slides[currentIndex];

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === currentIndex);
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === currentIndex);
      });

      playActiveVideo(activeSlide);

      resetTimer = window.setTimeout(() => {
        resetHiddenVideos(activeSlide);
      }, 800);

      const duration = Number(activeSlide.dataset.duration || 5000);

      timer = window.setTimeout(() => {
        showSlide(currentIndex + 1);
      }, duration);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(Number(dot.dataset.index || 0));
      });
    });

    showSlide(0);
  });
})();